module.exports = __webpack_public_path__ + "static/img/ve.f89dea2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/ve.png
// module id = L6W4
// module chunks = 18